import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const RaceDetail = () => {
  const { raceId } = useParams();
  const navigate = useNavigate();
  const [race, setRace] = useState({});
  const { allDogs, lenguage } = useSelector((state) => state);

  const crudHandler = (event) => {
    const { name } = event.target;
    if (name === "delete") {
      window.confirm(lenguage?"Are you sure you want to eliminate the breed?":"¿Estás seguro de que quieres eliminar la raza?") &&
        axios
          .delete(`/dogs/${raceId}`)
          .then((res) => {
            window.alert(res.data.message);
            navigate("/home");
          })
          .catch((err) => {
            window.alert(
             lenguage? "Error deleting the breed, please try again.": "Error al eliminar la raza, por favor intente nuevamente"
            );
          });
    }
    if (name === "modify") {
      navigate(`/modifyrace/${raceId}`);
    }
  };

  useEffect(() => {
    const raceData = allDogs.find((dog) => dog.id == raceId); //eslint-disable-line
    if (!raceData) {
      navigate("/home");
    }
    setRace(raceData);
  }, [raceId]); //eslint-disable-line
  return (
    <>
      <br />
      <h1>{lenguage ? "BREED IN DETAIL" : "RAZA EN DETALLE"}</h1>
      <section className="details_container">
        <section className="info-detail">
          <h2 className="detail-name">{race?.name}</h2>
          <div className="detail-id">
            <h3>ID</h3>
            <h4>{raceId}</h4>
          </div>
          <div className="detail-height">
            <h3>{lenguage ? "Height" : "Altura"}</h3>
            <h4>{race?.height?.metric} Cms</h4>
          </div>
          <div className="detail-weight">
            <h3>{lenguage ? "Weight" : "Peso"}</h3>
            <h4>{race?.weight?.metric} Kgs</h4>
          </div>
          <div className="detail-lifeSpan">
            <h3>{lenguage ? "Life span" : "Esperanza de vida"}</h3>
            <h4>{race?.life_span}</h4>
          </div>
          <div className="detail-temps">
            <h3>{lenguage ? "Temperament" : "Temperamento"}/s</h3>
            <ol className="detail-templist">
              {isNaN(race?.id)
                ? race?.Temperaments?.map((t) => <li key={t.id}>{t.name}</li>)
                : race?.temperament
                    ?.split(" ")
                    .map((t, i) => <li key={i}>{t}</li>)}
            </ol>
          </div>
        </section>
        <section className="sec-img-btns">
          <img src={race?.image?.url} alt={race?.name} />
          {isNaN(raceId) ? (
            <div className="btns-detail">
              <button
                onClick={crudHandler}
                name="modify"
                className="btn-modify"
              >
                {lenguage ? "Modify breed" : "Modificar raza"}
              </button>
              <button
                onClick={crudHandler}
                name="delete"
                className="btn-delete"
              >
                {lenguage ? "Delete breed" : "Eliminar raza"}
              </button>
            </div>
          ) : null}
        </section>
      </section>
    </>
  );
};

export default RaceDetail;
